import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { environment } from '../../environment';
import { AuthService } from '../services/auth.service';

/** Cookie сессии уходит только в API (CRM-122); `401` при вошедшем пользователе — сессия закончилась. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) return next(req);
  const auth = inject(AuthService);
  return next(req.clone({ withCredentials: true })).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) auth.expired();
      return throwError(() => error);
    })
  );
};
